import * as d3 from "d3";

var colors = d3
.scaleThreshold()
.domain([0.0, 0.1, 1.0])
.range(["#f0c36a", "#00ea00", "#009d00"]);

var colors = d3
.scaleThreshold()
.domain([-0.1,-0.05, 0.0, 0.2, 0.4])
.range(["#d66f2c", "#edb731", "#fff12c", "#c3d545", "#79b752", "#33a357"]);

var colors = d3
.scaleThreshold()
.domain([-0.1,-0.05, 0.0, 0.05, 0.1])
.range(["#808080", "#A0A0A0", "#C0C0C0", "#c3d545", "#79b752", "#33a357"]);

export default function colorMap(value) {
    return colors(value)
}